module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-coast-57bbd1c6c978d30bc2247a093ff6b907.svg";